import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Box,
  Paper,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';

function Faq() {
  const { t } = useTranslation();

  const faqs = [
    {
      question: t('faq.clients.question'),
      answer: t('faq.clients.answer'),
    },
    {
      question: t('faq.whyQuantikFlow.question'),
      answer: [
        t('faq.whyQuantikFlow.answer.0'),
        t('faq.whyQuantikFlow.answer.1'),
        t('faq.whyQuantikFlow.answer.2'),
      ],
    },
  ];

  return (
    <Box
      sx={{
        minHeight: '94.990vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(-45deg, #1976d2, #1565c0, #0d47a1, #42a5f5)',
        backgroundSize: '400% 400%',
        animation: 'gradientAnimation 15s ease infinite',
        color: '#fff',
        '@keyframes gradientAnimation': {
          '0%': { backgroundPosition: '0% 50%' },
          '50%': { backgroundPosition: '100% 50%' },
          '100%': { backgroundPosition: '0% 50%' },
        },
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
        >
          {t('faq.title')}
        </Typography>

        <Typography
          variant="subtitle1"
          textAlign="center"
          mb={5}
          sx={{ color: 'rgba(255,255,255,0.8)' }}
        >
          {t('faq.subtitle')}
        </Typography>

        {faqs.map((faq, index) => (
          <Paper
            elevation={3}
            sx={{
              mb: 3,
              borderRadius: 2,
              overflow: 'hidden',
              backgroundColor: 'rgba(255,255,255,0.1)',
              backdropFilter: 'blur(8px)',
              color: '#fff',
            }}
            key={index}
          >
            <Accordion disableGutters sx={{ bgcolor: 'transparent', color: '#fff' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}
                sx={{
                  px: 3,
                  py: 2,
                  '& .MuiTypography-root': {
                    fontWeight: 'medium',
                    fontSize: '1.1rem',
                  },
                }}
              >
                <Typography>{faq.question}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 3, pb: 3 }}>
                {Array.isArray(faq.answer) ? (
                  <ul style={{ paddingLeft: '1.5rem', margin: 0 }}>
                    {faq.answer.map((item, i) => (
                      <li key={i} style={{ marginBottom: '0.5rem' }}>
                        <Typography variant="body1" sx={{ color: '#fff' }}>
                          {item}
                        </Typography>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <Typography variant="body1" sx={{ color: '#fff' }}>
                    {faq.answer}
                  </Typography>
                )}
              </AccordionDetails>
            </Accordion>
          </Paper>
        ))}
      </Container>
    </Box>
  );
}

export default Faq;
